<template>
    <el-dialog
        :visible.sync="visible"
        :title="title"
        left>
        <el-form
            ref="form"
            :model="form"
            :status-icon="true"
            label-position="right"
            label-width="70px"
            label-suffix=":">
            <el-form-item :label="$t('Common.coach')">
                {{ coach ? coach.nickname : '' }}
            </el-form-item>
            <el-form-item :label="$t('Common.date')">
                <el-date-picker
                    class="work-copy-item"
                    ref="picker"
                    style="width: calc(100% - 40px)"
                    v-model="form.date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    :placeholder="$t('Common.choose_date2')">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('Coach.take_time')">
                <el-time-select
                    class="work-time-select"
                    v-model="form.timeFrom"
                    :default-value="time"
                    :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:55'
                    }"
                    :placeholder="$t('Coach.choose_time')">
                </el-time-select>
                &nbsp;{{ $t('Reception.Third.zhi') }}&nbsp;
                <el-time-select
                    class="work-time-select"
                    v-model="form.timeTo"
                    :default-value="time"
                    :picker-options="{
                        start: '00:00',
                        step: '00:05',
                        end: '23:55'
                    }"
                    :placeholder="$t('Coach.take_time')">
                </el-time-select>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{ $t('Common.close') }}</el-button>
            <el-button @click="confirm" type="primary">{{ $t('Common.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, DatePicker, TimeSelect } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElTimeSelect: TimeSelect,
    },
    data() {
        return {
            visible: false,
            title: this.$t('Coach.add_appoint_time'),
            form: {
                coachId: null,
                date: null,
                timeFrom: null,
                timeTo: null,
                type: 1, // 1-预约时间,2-请假时间
            },
            coach: null,
            type: null, // type 为 add 是添加，为 leave 是请假
            time: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        // 设置时间选择器打开默认值
        filterTime() {
            const date = new Date();
            let hours = date.toTimeString().substr(0, 2);
            let minutesI = date.toTimeString().substr(3, 1);
            let minutesII = date.toTimeString().substr(4, 1);
            if (minutesII > 0 && minutesII < 5) {
                minutesII = 5;
            } else if (minutesII > 5) {
                if (minutesI < 5) {
                    minutesI = Number(minutesI) + 1;
                } else {
                    hours = Number(hours) + 1;
                    minutesI = 0;
                }
                minutesII = 0;
            }
            this.time = `${hours}:${minutesI}${minutesII}`;
        },
        resetForm() {
            this.form = {};
            this.coach = null;
        },
        open(coach, date, type) {
            this.coach = coach;
            this.form.coachId = coach.id;
            // this.form.date = date;
            this.$set(this.form, 'date', date);
            if (type === 'add') {
                this.form.type = 1;
                this.title = this.$t('Coach.add_appoint_time');
            } else {
                this.form.type = 2;
                this.title = this.$t('Coach.add_leave_time');
            }
            this.filterTime();
            this.visible = true;
        },
        async confirm() {
            if (!this.form.date.length) this.form.date = this.form.date.format('YYYY-MM-DD');
            if (!this.form.timeFrom) return $ele.$message(this.$t('Coach.start_time'));
            if (!this.form.timeTo) return $ele.$message(this.$t('Coach.end_time'));
            if (this.$$filterPermission('课程-教练工作时间设置-添加/复制/删除私教上课时间')) {
                let data = false;
                await API.get('lesson/coach/time/check-conflict', {
                    params: this.form,
                }).then(res => {
                    if (!res) data = true;
                }).catch((err) => {
                    if (err.code === 409) {
                        $ele.$confirm(err.message, this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            cancelButtonText: this.$t('Common.cancel'),
                            type: 'warning',
                        }).then(() => {
                            this.postData();
                        }).catch(() => {
                            // $ele.$message('取消操作');
                        });
                    }
                });
                if (data) this.postData();
            } else {
                $ele.$alert(this.$t('Coach.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
            }
        },
        postData() {
            API.put('lesson/coach/time', this.form).then(() => {
                $ele.$message.success(this.$t('Message.save'));
                this.$emit('fetchData');
                this.visible = false;
            }).catch(err => {
                const lessonTimeFrom = `${this.form.date} ${this.form.timeFrom}:00`;
                const lessonTimeTo = `${this.form.date} ${this.form.timeTo}:00`;
                const url = `/course/?activeName=third&lessonBeginAt=${lessonTimeFrom}&lessonEndAt=${lessonTimeTo}&coachId=${this.form.coachId}`;
                if (err.code === 409) {
                    $ele.$alert(`${err.message}, <a class="fitness-blue" href="${url}">${$t('Coach.check')}</a>`, this.$t('Message.tip_title'), {
                        dangerouslyUseHTMLString: true
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">
.el-dialog {
    width: 500px;
    margin: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-dialog--center .el-dialog__body {
    padding: 25px 25px 0;
}
.work-time-select {
    width: 154px !important;
}
</style>
